<template>
  <div> <!-- Only one element for Transition -->
    <small class="mb-4 text-center d-block text-muted"><em>
      Ces informations ne sont visibles et modifiables que par un administrateur.
    </em></small>
    <div class="row">
      <div class="col-12">
        <TextInputComponent
          value-key="admin.discountLabel"
          label="Nom de la remise"
          placeholder="Indiquez le Nom de la remise"
          :required="false"
          class="mb-3"
        />
      </div>
      <div class="col-6">
        <NumberInputComponent
          value-key="admin.discount"
          label="Remise accordée"
          placeholder="Indiquez le montant de la remise"
          :required="false"
          :min="0"
          class="mb-3"
          :group-text="participation?.admin?.discountType === TravelDbDiscountTypeEnum.Percent ? '%': '€'"
        />
      </div>
      <div class="col-6">
        <SelectInputComponent
          value-key="admin.discountType"
          label="Type de remise"
          placeholder="Sélectionnez le type de remise"
          :required="true"
          class="mb-3"
          :options="Object.values(TravelDbDiscountTypeEnum).map(type => ({ value: type, label: GetTravelDbDiscountTypeLabel(type, participation?.travel.priceTTC??false) }))"
           />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <TextInputComponent
          value-key="admin.notes"
          label="Notes pour les administrateurs"
          placeholder="Indiquez vos notes pour les administrateurs"
          type="multiline"
          :required="false"
          class="mb-3"
          :rows="6"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { GetTravelDbDiscountTypeLabel } from '@/compositions/helper';

const participation = defineModel<UserParticipation>();

</script>
